import { RecordType } from '@petconsole/pure-base';

const ourKeysInclude = (record: RecordType, key: string) => {
  const keys = Object.keys(record);

  return keys.includes(key);
};

export default ourKeysInclude;
